import {Component, computed, inject, input, ChangeDetectionStrategy} from "@angular/core";
import {toObservable, toSignal} from "@angular/core/rxjs-interop";
import {combineLatest} from "rxjs";
import {map, switchMap} from "rxjs/operators";
import {AssetImageHistoryService, ImageHistoryEntry} from "../../../asset/asset-image-history.service";
import {CameraFrame, PhotoPlayerComponent} from "../photo-player/photo-player.component";
import {DateRange, evaluateDateRange} from "../../../../common/forms/period-select/period-select.component";
import {LorenMetering} from "../../../loren-assets/interfaces/loren-metering.interface";

@Component({
    selector: "asset-image-history-player",
    imports: [PhotoPlayerComponent],
    styles: `
        :host {
            display: block;
            margin: 0 auto;
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `<photo-player [frames]="frames()" [title]="title()"/>`,
})
export class AssetImageHistoryPlayerComponent {
    private readonly service = inject(AssetImageHistoryService);

    metering = input.required<LorenMetering>();
    period = input.required<DateRange>();

    title = computed(() => this.metering().description);

    frames = toSignal(
        combineLatest([toObservable(this.metering), toObservable(this.period)]).pipe(
            switchMap(([metering, period]) => {
                const [from, to] = evaluateDateRange(period);
                return this.service.getHistory(metering.id, from, to);
            }),
            map(({items}) => items.map(toFrame)),
        ),
        {initialValue: [] as CameraFrame[]},
    );
}

function toFrame(entry: ImageHistoryEntry): CameraFrame {
    return {
        id: entry.time,
        capturedAt: entry.time,
        imageUrl: entry.imageUrl,
    };
}
